import { GetQuestionsOptions } from './get-questions'

export const serviceQuestionKeys = {
  // Base keys
  all: ['service-questions'] as const,

  // Question lists
  lists: () => [...serviceQuestionKeys.all, 'list'] as const,
  list: (filters: GetQuestionsOptions) => [...serviceQuestionKeys.lists(), { filters }] as const,

  // Question details
  details: () => [...serviceQuestionKeys.all, 'detail'] as const,
  detail: (qid: string) => [...serviceQuestionKeys.details(), qid] as const,
}
